declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ActorIdentitiesRequest, ActorIdentitiesController } from '../../../../../models/actor/actor';
import { ActorService } from '../../../../../services/actor.service';
import { DBOperation } from '../../../../../enums/enum';

import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { CustomDateTimeService } from '../../../../../services/datetime.service';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';


import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';



@Component({
  selector: 'identities',
  templateUrl: './identitiesinfo.modal.html',
  styleUrls: ['./identitiesinfo.modal.scss']
})

export class NgbIdentitiesinfoModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  @Input() IsShowDl: boolean = false;
  @Input() IsShowPassport: boolean = false;

  @Input() ActorCode: number;
  @Input() CurrentActorIdentitiesControllerByCode: ActorIdentitiesController;

  CurrentActorIdentitiesRequest: ActorIdentitiesRequest;
  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;

  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();

  ValidTo: NgbDateStruct;
  ValidFrom: NgbDateStruct;



  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private router: Router, private route: ActivatedRoute, private actorservice: ActorService, private customdatetimeservice: CustomDateTimeService, private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) { }
  ngOnInit() {

    this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);

    this.MaxDateV.setFullYear(this.MaxDateV.getFullYear() +80);
    this.maxDate = { year: this.MaxDateV.getFullYear(), month: this.MaxDateV.getMonth() + 1, day: this.MaxDateV.getDate() };
    this.minDate = { year: this.MinDateV.getFullYear(), month: this.MinDateV.getMonth() + 1, day: this.MinDateV.getDate() };


    this.CanAdjustgetTimezoneOffset = AppData.CanAdjustgetTimezoneOffset;

    this.CurrentActorIdentitiesRequest = new ActorIdentitiesRequest();
    //alert(this.CurrentActorIdentitiesControllerByCode.CredentialNumber);
    this.CurrentActorIdentitiesRequest.IssuingAuthority = this.CurrentActorIdentitiesControllerByCode.IssuingAuthority;
    this.CurrentActorIdentitiesRequest.CredentialNumber = this.CurrentActorIdentitiesControllerByCode.CredentialNumber;
    this.CurrentActorIdentitiesRequest.ValidFrom = this.CurrentActorIdentitiesControllerByCode.ValidFrom;
    this.CurrentActorIdentitiesRequest.ValidTo = this.CurrentActorIdentitiesControllerByCode.ValidTo;
    this.CurrentActorIdentitiesRequest.AdditionalDetails = this.CurrentActorIdentitiesControllerByCode.AdditionalDetail;
    this.CurrentActorIdentitiesRequest.ActorCode = this.ActorCode;
    this.CurrentActorIdentitiesRequest.ActorCredentialCode = this.CurrentActorIdentitiesControllerByCode.ActorCredentialCode;
    this.CurrentActorIdentitiesRequest.Remarks = this.CurrentActorIdentitiesControllerByCode.Remarks;
    this.CurrentActorIdentitiesRequest.CredentialType = this.CurrentActorIdentitiesControllerByCode.CredentialType;
    
    this.CurrentActorIdentitiesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    if (this.CurrentActorIdentitiesRequest.ValidFrom  != null) {
      var SValidFrom = new Date(this.CurrentActorIdentitiesRequest.ValidFrom );
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidFrom = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    if (this.CurrentActorIdentitiesRequest.ValidTo  != null) {
      var SValidTo = new Date(this.CurrentActorIdentitiesRequest.ValidTo );
      if (SValidTo.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidTo = {

          year: SValidTo.getFullYear(),
          month: SValidTo.getMonth() + 1,
          day: SValidTo.getDate()
        }
      }
    }




  }
  onCredentialTypeByGroup(event: any) {

    if (event != null) {

      this.CurrentActorIdentitiesRequest.CredentialType = event;


    }
    else {

      this.CurrentActorIdentitiesRequest.CredentialType = "";
    }

  }


  //if(this.ValidFrom != null) {



  //  this.CurrentActorEditEducationInfoRequest.StartFrom = new Date(this.parserFormatter.format(this.ValidFrom));;
  //}
  onSubmit() {
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorIdentitiesRequest.ConditionalOperator = 2;

    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  this.CurrentActorIdentitiesRequest.ValidFrom = this.customdatetimeservice.converToLocalTime(this.CurrentActorIdentitiesRequest.ValidFrom);
    //  this.CurrentActorIdentitiesRequest.ValidTo = this.customdatetimeservice.converToLocalTime(this.CurrentActorIdentitiesRequest.ValidTo);
    //}

    if (this.ValidFrom != null) {



      this.CurrentActorIdentitiesRequest.ValidFrom = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorIdentitiesRequest.ValidTo = new Date(this.parserFormatter.format(this.ValidTo));;
    }

    this.actorservice.SaveActorIdentities(this.CurrentActorIdentitiesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();
        }
      }
      );

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  //
  ///////////////////DetailGrid
  //Grid Vars start
  disREADONLY: boolean = false;

  ddbops: DBOperation;
  dcolumns: any[] = [
    {
      display: 'Identity Type',
      variable: 'CredentialType',
      filter: 'text',
    },
    {
      display: 'Identity Number',
      variable: 'CredentialNumber',
      filter: 'text'
    },
    {
      display: 'ValidFrom',
      variable: 'ValidFrom',
      filter: 'date'
    }
    ,
    {
      display: 'ValidTo',
      variable: 'ValidTo',
      filter: 'date'
    }
    ,
    {
      display: 'IssuingAuthority',
      variable: 'IssuingAuthorityLongValue',
      filter: 'text'
    }
    ,
    {
      display: 'Remarks',
      variable: 'Remarks',
      filter: 'text'
    }
    ,
    {
      display: 'AdditionalDetail',
      variable: 'AdditionalDetail',
      filter: 'text'
    }


  ];




}
